import React from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import { buildUrl, buildGoogleOauthUrl } from "../utils/helper";
import "./GoogleButton.scss";

const GoogleButtonComponent = (props) => {
  const onClickHandle = (e) => {
    e.preventDefault();

    if (props.onClick) props.onClick(e);

    const uri = buildGoogleOauthUrl(props.redirectURI, props.state);
    window.location.replace(uri);
  };

  return (
    <Button
      className={"google " + props.className}
      primary={props.primary === undefined ? true : props.primary}
      disabled={props.disabled}
      icon={props.icon}
      onClick={onClickHandle}
      iconClass="googleIcon"
      imageUrl={buildUrl("assets/icons/google_G_logo.svg")}
      title={props.title}
      buttonWrapperClassName={props.buttonWrapperClassName}
      customTooltipContent={props.customTooltipContent}
      label={props.label ? props.label : "Google"}
      notUseTooltip={true}
    />
  );
};

GoogleButtonComponent.propTypes = {
  buttonWrapperClassName: PropTypes.string,
  className: PropTypes.string,
  customTooltipContent: PropTypes.object,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  icon: PropTypes.string,
  iconClass: PropTypes.string,
  imageUrl: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  redirectURI: PropTypes.string.isRequired,
  state: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};

export default GoogleButtonComponent;
